import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';

const selectSectorInitializedWithSeats = createSelector(
    orm,
    dbSelector,
    (state, sectorHash) => sectorHash,
    ({ Sector }, sectorHash) => {
        const sector = Sector.all().toModelArray()
            .find(sector => sector.hash === sectorHash);

        if (!sector) {
            return false;
        }

        return sector.initializedWithSeats;
    },
);

export default selectSectorInitializedWithSeats;
